import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { MsalService} from '@azure/msal-angular'; 
import { HOME_ITEMS } from '../../config/home/home-config';
import { LoginService } from 'src/app/services/login.service';
import { HomeItem } from '../../models/home-item/home-item.model';
import { FacturaService } from 'src/app/services/factura.service';
import { PaginationService } from 'src/app/services/pagination.service';
import { NavigationService } from 'src/app/services/navigation.service'; 

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
  
export class HomeComponent {

  homes: HomeItem[] = HOME_ITEMS;
  rol: any;
  token: any;
  
  cardOpen: boolean[] = [];

  public roles_nombres: any;
  public filteredHomes: any;

  public mostrarContadores : any [] = [
    {
      nombre: 'Pendientes',
      busqueda: 'Pendiente',
      color: 'primary'
    },
    {
      nombre: 'Aclaración',
      busqueda: 'Aclaracion',
      color: 'warning'
    },
    {
      nombre: 'VoBo',
      busqueda: 'VoBo',
      color: 'success'
    }
  ];

  cardData = {
    holder_name: '',
    card_number: '',
    expiration_month: '',
    expiration_year: '',
    cvv2: ''
  };

  constructor(
    private router: Router, 
    private msalService: MsalService,
    public loginService: LoginService,
    private pagination: PaginationService,
    private facturaService: FacturaService,
    private navigationService: NavigationService) { }

  ngOnInit() {
    this.obtenerDatos();
    this.pagination.setLastAction('');
  }

  obtenerDatos() {
    this.token = String(localStorage.getItem('token1'));
    this.msalService.initialize();
    this.navigationService.disableNavigation();
    this.getUserNameRol();
  }

  getUserNameRol() {
  // Obtiene el rol del ID
  let idSeleccion = localStorage.getItem('rol_id') || '';
  
  // Si el rol id = 14, entonces son varios roles seleccionados
  if (idSeleccion === '14') {
    let rolesString = localStorage.getItem('roles_nombre') || '';
    
    // Convierte el string de roles a un array de strings, quitando espacios extra
    this.roles_nombres = rolesString.split(',').map((role: string) => role.trim());

  } else {
    // Si el rol id != 14, entonces se coloca el rol ya obtenido
    this.rol = localStorage.getItem('rol') || '';
    
    // Asegura que roles_nombres sea un array incluso si hay un solo rol
    this.roles_nombres = [this.rol];
  }
  this.colocarWidgets();
}

colocarWidgets() { 
  const rolesNombres = this.roles_nombres; // Asegúrate de que este nombre coincida
  const filteredHomes = this.homes.filter(item => {
    // Si los roles son 'todos', permitimos todos los widgets
    if (item.validacion.roles === 'todos') {
      return true;
    }

    // Si los roles son un array, filtramos por coincidencias
    if (Array.isArray(item.validacion.roles)) {
      return item.validacion.roles.some((role: string) => rolesNombres.includes(role));
    }

    return false; // En caso de algún tipo inesperado, lo excluimos
  });

  // Ahora filteredHomes contendrá solo los elementos que coincidan con los roles o 'todos'
  this.filteredHomes = filteredHomes; 
  this.filteredHomes.forEach(() => this.cardOpen.push(false));
}

handleClick(url: string, status: string): void {
  // Redirigir a la URL dinámica con el parámetro de consulta "estado"
  this.router.navigate([`/${url}`], { queryParams: { estado: status } });
}

toggleCard(i: number, nombreContador:string) {
  this.cardOpen[i] = !this.cardOpen[i]; // Cambiar el estado abierto/cerrado  
  this.contadores(i,nombreContador)
}

contadores(i: number, nombreContador: string) {

  this.facturaService.validacionContadores(nombreContador, this.token).subscribe(
    response => {
      this.mostrarContadores = this.mostrarContadores.map((item) => {
        const propiedadDinamica = `${nombreContador}cantidad`;
        // Asigna el valor de la respuesta a la propiedad dinámica en el contador
        if (response[item.busqueda] !== undefined) {
          item[propiedadDinamica] = response[item.busqueda];
        }
        return item;
      });
    },
    error => {
      console.error('Error en la petición:', error);
    }
  );
}

}
  
